import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "resident-report-detail" }
const _hoisted_2 = {
  key: 0,
  class: "resident-report-detail__loading"
}
const _hoisted_3 = {
  key: 1,
  class: "resident-report-detail__loading"
}
const _hoisted_4 = { class: "resident-report-detail__header" }
const _hoisted_5 = { class: "resident-report-detail__title-container" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "resident-report-detail__header-actions" }
const _hoisted_9 = { class: "resident-report-detail__status-text" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "resident-report-detail__signature-text" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  type: "button",
  class: "resident-report-detail__icon-action",
  "data-report-create-open-drawer": "",
  "data-report-drawer-mode": "edit",
  "aria-label": "Редактировать отчёт"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "resident-report-detail__general-section" }
const _hoisted_18 = { class: "resident-report-detail__general-section--field-row" }
const _hoisted_19 = { class: "field-with-label" }
const _hoisted_20 = { class: "field-with-label__value" }
const _hoisted_21 = { class: "field-with-label" }
const _hoisted_22 = { class: "field-with-label__value" }
const _hoisted_23 = { class: "resident-report-detail__general-section--field-row" }
const _hoisted_24 = { class: "field-with-label" }
const _hoisted_25 = { class: "field-with-label__value" }
const _hoisted_26 = { class: "field-with-label" }
const _hoisted_27 = { class: "field-with-label__value" }
const _hoisted_28 = { class: "resident-report-detail__metrics-section" }
const _hoisted_29 = { class: "resident-report-detail__metrics-section--table" }
const _hoisted_30 = { class: "resident-report-detail__details-section" }
const _hoisted_31 = { class: "resident-report-detail__details-list" }
const _hoisted_32 = { class: "resident-report-detail__details-item--label" }
const _hoisted_33 = { class: "resident-report-detail__details-item--value" }
const _hoisted_34 = { class: "resident-report-detail__section" }
const _hoisted_35 = {
  key: 0,
  class: "resident-report-detail__documents"
}
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "resident-report-detail__document-content" }
const _hoisted_38 = ["href"]
const _hoisted_39 = {
  key: 1,
  class: "resident-report-detail__empty-documents"
}
const _hoisted_40 = { class: "resident-report-detail__section resident-report-detail__manager-review" }
const _hoisted_41 = { class: "resident-report-detail__manager-review-fields" }
const _hoisted_42 = {
  key: 0,
  class: "field-with-label"
}
const _hoisted_43 = { class: "field-with-label__value" }
const _hoisted_44 = {
  key: 1,
  class: "field-with-label"
}
const _hoisted_45 = { class: "resident-report-detail__documents" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "resident-report-detail__document-content" }
const _hoisted_48 = ["href"]

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { getAssetsPath } from '@/js/utils/getAssetsDir';
import {
  getReportIdFromUrl,
  getReportListHref,
  navigateToReportList,
} from './get-report-id-from-url';
import { fetchReportDetail } from '../resident-report/report-api';
import { requestDeleteReport } from '../resident-report-drawer';
import {
  getReportDetailActions,
  mapApiReportToDetailView,
  type ReportDetailViewModel,
} from './map-report-detail';

const REPORT_EDIT_DATA_ID = 'residentReportEditData';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const SIGNED_ICON = getAssetsPath('/assets/images/icons/resident-lk/signed.svg');
const NOT_SIGNED_ICON = getAssetsPath('/assets/images/icons/resident-lk/not-signed.svg');
const LEFT_ARROW_ICON = getAssetsPath('/assets/images/icons/share-icons/left-arrow.svg');
const DOWNLOAD_ICON = getAssetsPath('/assets/images/icons/share-icons/download-icon.svg');
const EDIT_ICON = getAssetsPath('/assets/images/icons/share-icons/edit-icon.svg');
const DELETE_ICON = getAssetsPath('/assets/images/icons/share-icons/delete-icon.svg');
const DOC_PDF_ICON = getAssetsPath('/assets/images/icons/doc/doc_pdf.svg');
const backUrl = getReportListHref();

function handleBackClick(event: MouseEvent): void {
  event.preventDefault();
  navigateToReportList();
}

function handleDeleteClick(): void {
  if (!report.value?.id) return;
  requestDeleteReport(report.value.id);
}

const loading = ref(true);
const error = ref('');
const report = ref<ReportDetailViewModel | null>(null);
let cleanupReportReload: (() => void) | null = null;

const reportActions = computed(() =>
  getReportDetailActions(report.value?.statusModifier ?? 'draft'),
);

const hasHeaderActions = computed(
  () =>
    reportActions.value.canDownload || reportActions.value.canEdit || reportActions.value.canDelete,
);

const hasManagerReview = computed(() => {
  if (!report.value || report.value.statusModifier !== 'revision') {
    return false;
  }

  return Boolean(report.value.commentReview) || report.value.managerFiles.length > 0;
});

onMounted(() => {
  bindReportReload();
  loadReport();
});

onBeforeUnmount(() => {
  cleanupReportReload?.();
});

watch(report, (value) => {
  syncEditPayload(value?.editPayload ?? null);
});

function syncEditPayload(payload: ReportDetailViewModel['editPayload'] | null): void {
  let script = document.getElementById(REPORT_EDIT_DATA_ID) as HTMLScriptElement | null;

  if (!script) {
    script = document.createElement('script');
    script.type = 'application/json';
    script.id = REPORT_EDIT_DATA_ID;
    document.body.appendChild(script);
  }

  script.textContent = payload ? JSON.stringify(payload) : '';
}

function bindReportReload(): void {
  const reloadReport = (): void => {
    void loadReport({ silent: Boolean(report.value) });
  };

  window.addEventListener('residentReports:changed', reloadReport);
  cleanupReportReload = () => {
    window.removeEventListener('residentReports:changed', reloadReport);
    cleanupReportReload = null;
  };
}

async function loadReport(options: { silent?: boolean } = {}): Promise<void> {
  if (!options.silent) {
    loading.value = true;
  }
  error.value = '';

  const reportId = getReportIdFromUrl();
  if (!reportId) {
    error.value = 'Не удалось определить отчёт';
    loading.value = false;
    return;
  }

  try {
    const data = await fetchReportDetail(reportId);
    report.value = mapApiReportToDetailView(reportId, data);
  } catch (loadError) {
    error.value = loadError instanceof Error ? loadError.message : 'Не удалось загрузить отчёт';
    report.value = null;
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Загрузка отчёта..."))
      : (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(error.value), 1))
        : (report.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("header", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("a", {
                    href: _unref(backUrl),
                    "data-barba-prevent": "self",
                    "aria-label": "Вернуться к списку отчётов",
                    onClick: handleBackClick
                  }, [
                    _createElementVNode("img", {
                      src: _unref(LEFT_ARROW_ICON),
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, _hoisted_7)
                  ], 8, _hoisted_6),
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "resident-report-detail__title-container--title" }, "Отчет", -1))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["resident-report-detail__status", `resident-report-detail__status--${report.value.statusModifier}`])
                  }, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "resident-report-detail__status-dot" }, null, -1)),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(report.value.status), 1)
                  ], 2),
                  (reportActions.value.showSignature)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "resident-report-detail__header-actions--divider" }, null, -1)),
                        _createElementVNode("div", {
                          class: _normalizeClass(["resident-report-detail__signature", 
                report.value.isSigned
                  ? 'resident-report-detail__signature--signed'
                  : 'resident-report-detail__signature--unsigned'
              ])
                        }, [
                          _createElementVNode("img", {
                            src: report.value.isSigned ? _unref(SIGNED_ICON) : _unref(NOT_SIGNED_ICON),
                            alt: "",
                            "aria-hidden": "true"
                          }, null, 8, _hoisted_10),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(report.value.isSigned ? 'Подписан' : 'Не подписан'), 1)
                        ], 2)
                      ], 64))
                    : _createCommentVNode("", true),
                  (hasHeaderActions.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "resident-report-detail__header-actions--divider" }, null, -1)),
                        (reportActions.value.canDownload)
                          ? (_openBlock(), _createBlock(_component_a_tooltip, {
                              key: 0,
                              title: "Скачать",
                              placement: "bottom",
                              "overlay-class-name": "resident-report-detail__icon-action-tooltip"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  class: "resident-report-detail__icon-action",
                                  href: report.value.downloadUrl,
                                  target: "_blank",
                                  rel: "noopener",
                                  "aria-label": "Скачать отчёт"
                                }, [
                                  _createElementVNode("img", {
                                    src: _unref(DOWNLOAD_ICON),
                                    alt: "",
                                    "aria-hidden": "true"
                                  }, null, 8, _hoisted_13)
                                ], 8, _hoisted_12)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (reportActions.value.canEdit)
                          ? (_openBlock(), _createBlock(_component_a_tooltip, {
                              key: 1,
                              title: "Редактировать",
                              placement: "bottom",
                              "overlay-class-name": "resident-report-detail__icon-action-tooltip"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", _hoisted_14, [
                                  _createElementVNode("img", {
                                    src: _unref(EDIT_ICON),
                                    alt: "",
                                    "aria-hidden": "true"
                                  }, null, 8, _hoisted_15)
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (reportActions.value.canDelete)
                          ? (_openBlock(), _createBlock(_component_a_tooltip, {
                              key: 2,
                              title: "Удалить",
                              placement: "bottom",
                              "overlay-class-name": "resident-report-detail__icon-action-tooltip"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "resident-report-detail__icon-action",
                                  "aria-label": "Удалить отчёт",
                                  onClick: handleDeleteClick
                                }, [
                                  _createElementVNode("img", {
                                    src: _unref(DELETE_ICON),
                                    alt: "",
                                    "aria-hidden": "true"
                                  }, null, 8, _hoisted_16)
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _cache[18] || (_cache[18] = _createElementVNode("hr", { class: "resident-report-detail__divider header-divider" }, null, -1)),
              _createElementVNode("section", _hoisted_17, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "resident-report-detail__section-title" }, "Общее", -1)),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "field-with-label__label" }, "Название", -1)),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(report.value.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "field-with-label__label" }, "Дата создания", -1)),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(report.value.createdAt), 1)
                  ])
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "resident-report-detail__general-section--divider" }, null, -1)),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "field-with-label__label" }, "Организация", -1)),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(report.value.companyName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "field-with-label__label" }, "Отчетный период", -1)),
                    _createElementVNode("span", _hoisted_27, _toDisplayString(report.value.reportYear), 1)
                  ])
                ])
              ]),
              _cache[19] || (_cache[19] = _createElementVNode("hr", { class: "resident-report-detail__divider" }, null, -1)),
              _createElementVNode("section", _hoisted_28, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "resident-report-detail__metrics-section--title-container" }, [
                  _createElementVNode("span", { class: "resident-report-detail__metrics-section--title" }, "Показатели"),
                  _createElementVNode("span", { class: "resident-report-detail__metrics-section--description" }, " За отчетный выбранный период. ")
                ], -1)),
                _createElementVNode("table", _hoisted_29, [
                  _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Показатель"),
                      _createElementVNode("th", null, "План"),
                      _createElementVNode("th", null, "Факт"),
                      _createElementVNode("th", null, "Отклонение, %")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(report.value.metrics, (metric) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: metric.label
                      }, [
                        _createElementVNode("td", null, _toDisplayString(metric.label), 1),
                        _createElementVNode("td", null, _toDisplayString(metric.plan), 1),
                        _createElementVNode("td", null, _toDisplayString(metric.fact), 1),
                        _createElementVNode("td", null, _toDisplayString(metric.deviation), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _cache[20] || (_cache[20] = _createElementVNode("hr", { class: "resident-report-detail__divider" }, null, -1)),
              _createElementVNode("section", _hoisted_30, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "resident-report-detail__section-title" }, "Детали", -1)),
                _createElementVNode("dl", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(report.value.details, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.label,
                      class: "resident-report-detail__details-item"
                    }, [
                      _createElementVNode("span", _hoisted_32, _toDisplayString(item.label), 1),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(item.value), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _cache[21] || (_cache[21] = _createElementVNode("hr", { class: "resident-report-detail__divider" }, null, -1)),
              _createElementVNode("section", _hoisted_34, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "resident-report-detail__section-title" }, "Документы", -1)),
                (report.value.documents.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_35, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(report.value.documents, (file) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: file.url + file.name,
                          class: "resident-report-detail__document"
                        }, [
                          _createElementVNode("img", {
                            src: _unref(DOC_PDF_ICON),
                            alt: "",
                            class: "resident-report-detail__document-icon"
                          }, null, 8, _hoisted_36),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("a", {
                              href: file.url,
                              target: "_blank",
                              rel: "noopener",
                              download: ""
                            }, _toDisplayString(file.name), 9, _hoisted_38),
                            _createElementVNode("span", null, _toDisplayString(file.format) + " / " + _toDisplayString(file.size), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_39, "Документы не загружены"))
              ]),
              (hasManagerReview.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[17] || (_cache[17] = _createElementVNode("hr", { class: "resident-report-detail__divider" }, null, -1)),
                    _createElementVNode("section", _hoisted_40, [
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "resident-report-detail__section-title" }, "Комментарий менеджера", -1)),
                      _createElementVNode("div", _hoisted_41, [
                        (report.value.commentReview)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "field-with-label__label" }, "Комментарий", -1)),
                              _createElementVNode("span", _hoisted_43, _toDisplayString(report.value.commentReview), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (report.value.managerFiles.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "field-with-label__label" }, "Прикрепленный файл", -1)),
                              _createElementVNode("ul", _hoisted_45, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(report.value.managerFiles, (file) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: file.url + file.name,
                                    class: "resident-report-detail__document"
                                  }, [
                                    _createElementVNode("img", {
                                      src: _unref(DOC_PDF_ICON),
                                      alt: "",
                                      class: "resident-report-detail__document-icon"
                                    }, null, 8, _hoisted_46),
                                    _createElementVNode("div", _hoisted_47, [
                                      _createElementVNode("a", {
                                        href: file.url,
                                        target: "_blank",
                                        rel: "noopener",
                                        download: ""
                                      }, _toDisplayString(file.name), 9, _hoisted_48),
                                      _createElementVNode("span", null, _toDisplayString(file.format) + " / " + _toDisplayString(file.size), 1)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
  ]))
}
}

})